<div class="wrapper">
  <ng-content/>

  <!--  Close BUTTON  -->
  @if (isFullScreen && showButtons) {
    <div
      class="map-action close-section"
      (click)="closeMap()"
      >
      <mat-icon
        class="sidenav-icon"
      >close</mat-icon>
    </div>
  }

  <!--  ZOOM IN BUTTON  -->
  @if (showButtons) {
    <div
      class="map-action zoom-in-section"
      (click)="zoomIn()"
      >
      <mat-icon
        class="zoom-in-icon"
        svgIcon="plus"
        />
    </div>
  }

  <!--  ZOOM OUT BUTTON  -->
  @if (showButtons) {
    <div
      class="map-action zoom-out-section"
      (click)="zoomOut()"
      >
      <mat-icon
        class="zoom-out-icon"
        svgIcon="minus"
        />
    </div>
  }

  <!--  FULL SCREEN BUTTON  -->
  @if (!isFullScreen && showButtons) {
    <div
      class="map-action full-screen-section"
      (click)="openInFullScreen()"
      >
      <mat-icon
        class="full-screen-icon"
        svgIcon="full-screen"
        />
    </div>
  }

</div>
